var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2358_41486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0066 24.1201L7.75344 16.3667L0 12.1267L7.75344 7.87356L12.0066 0.120117L16.2466 7.87356L24 12.1267L16.2466 16.3667L12.0066 24.1201Z",
    fill: "url(#paint0_linear_2358_41486)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2358_41486",
    x1: 3.81818,
    y1: 0.120118,
    x2: 34.6364,
    y2: 30.9383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAD9FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2358_41486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.120117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStarIcon);
export default __webpack_public_path__ + "static/media/blue-star-icon.eab387f29d6d80b95b99466c837a52f4.svg";
export { ForwardRef as ReactComponent };